"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _AxisRestrictionApi_axisRestriction;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxisRestrictionApi = void 0;
const AbstractSnapRestrictionApi_1 = require("../../AbstractSnapRestrictionApi");
class AxisRestrictionApi extends AbstractSnapRestrictionApi_1.AbstractSnapRestrictionApi {
    // #endregion Properties (1)
    // #region Constructors (1)
    constructor(restriction) {
        super(restriction);
        // #region Properties (1)
        _AxisRestrictionApi_axisRestriction.set(this, void 0);
        __classPrivateFieldSet(this, _AxisRestrictionApi_axisRestriction, restriction, "f");
    }
}
exports.AxisRestrictionApi = AxisRestrictionApi;
_AxisRestrictionApi_axisRestriction = new WeakMap();
//# sourceMappingURL=AxisRestrictionApi.js.map